import React, { Component } from "react";
import {
  GET,
  GET_FILE,
  alert,
  saveAs,
  loading,
  NavbarCustomer,
  t,
  sortOptions,
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from "chart.js";
import { Bar, Doughnut } from "react-chartjs-2";
import { getProfile } from "../../utils/localStorage";
import { isCustomerScopeReady } from "../../utils/customerScope";
import { CHART_COLORS, formatDate, statusColor, translateKey } from "../../utils/customerReport";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

const BAR_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false } },
  scales: { y: { beginAtZero: true, ticks: { precision: 0 } } },
};

const DONUT_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: "65%",
  plugins: { legend: { position: "bottom", labels: { boxWidth: 12, font: { size: 11 } } } },
};

export default class AssetReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // -----------------------------------
      // Filter States
      // -----------------------------------
      filter_category: "",
      filter_status: "",
      filter_location: "",

      summary: {
        total_assets: 0,
        operational: 0,
        under_maintenance: 0,
        warranty_expiring: 0
      },

      status_distribution: [],
      maintenance_by_asset: [],
      data: [],
      lookups: { asset_categories: [], locations: [] },
      exporting: "",
      loaded: false
    };
  }

  async componentDidMount() {
    if (!isCustomerScopeReady(getProfile())) {
      loading(false);
      return;
    }

    await Promise.all([this.GetLookups(), this.Get()]);
    loading(false);
  }

  GetLookups = async () => {
    const result = await GET("customer/reports/lookups");
    if (result?.status === true) this.setState({ lookups: result.data || { asset_categories: [], locations: [] } });
  };

  filterParams = () => ({
    category: this.state.filter_category || "",
    status: this.state.filter_status || "",
    location: this.state.filter_location || "",
  });

  Get = async () => {
    loading(true);

    const result = await GET("customer/reports/asset-report", { ...this.filterParams(), page_size: 200 });

    if (result?.status === true) {
      const data = result.data || {};
      this.setState({
        summary: data.summary || this.state.summary,
        status_distribution: Array.isArray(data.status_distribution) ? data.status_distribution : [],
        maintenance_by_asset: Array.isArray(data.maintenance_by_asset) ? data.maintenance_by_asset : [],
        data: Array.isArray(data.data) ? data.data : [],
        loaded: true
      });
    }

    loading(false);
  };

  exportFile = async (format) => {
    this.setState({ exporting: format });

    const result = await GET_FILE("customer/reports/asset-report/export", {
      ...this.filterParams(),
      format,
      lang: localStorage.getItem("lang") === "EN" ? "en" : "th",
    });

    this.setState({ exporting: "" });

    if (result?.status !== true) {
      alert("", "error", t("error"), result?.message || t("export_failed"));
      return;
    }

    const stamp = new Date().toISOString().slice(0, 10);
    saveAs(result.blob, `asset-report_${stamp}.${format === "pdf" ? "pdf" : "xlsx"}`);
  };

  distributionData = () => ({
    labels: this.state.status_distribution.map((row) => translateKey(row.key)),
    datasets: [
      {
        data: this.state.status_distribution.map((row) => row.count),
        backgroundColor: this.state.status_distribution.map((_, index) => CHART_COLORS[index % CHART_COLORS.length]),
        borderRadius: 6,
      },
    ],
  });

  maintenanceData = () => ({
    labels: this.state.maintenance_by_asset.map((row) => row.key),
    datasets: [
      {
        data: this.state.maintenance_by_asset.map((row) => row.count),
        backgroundColor: this.state.maintenance_by_asset.map((_, index) => CHART_COLORS[index % CHART_COLORS.length]),
        borderWidth: 0,
      },
    ],
  });

  render() {
    const { summary, data, status_distribution, maintenance_by_asset, lookups, filter_category, filter_status, filter_location, exporting, loaded } = this.state;

    return (
      <div className="w-100 min-vh-100 pb-5" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarCustomer />
        <div className="body px-4 mt-3">


                    {/* Header Section */}
                    <div className="mb-4">
                      <h3 className="fw-bold mb-1 text-dark">{t("asset_report")}</h3>
                      <div className="text-secondary text-14">{t("equipment_status_desc")}</div>
                    </div>
          
                    {/* Filter Bar */}
                    <div className="bg-white rounded-4 shadow-sm p-3 mb-4 d-flex flex-wrap align-items-end gap-3 border border-light">
                      <div className="flex-grow-1" style={{ minWidth: '200px' }}>
                        <label className="form-label text-secondary text-12 fw-bold mb-2">{t("asset_category")}</label>
                        <select
                          className="form-select rounded-3 border-light bg-light text-dark fw-bold text-13 shadow-none"
                          value={filter_category}
                          onChange={(e) => this.setState({ filter_category: e.target.value })}
                        >
                          <option value="">{t("all_categories")}</option>
                          {sortOptions(lookups.asset_categories).map((category) => (
                            <option key={category} value={category}>{category}</option>
                          ))}
                        </select>
                      </div>
                      <div className="flex-grow-1" style={{ minWidth: '200px' }}>
                        <label className="form-label text-secondary text-12 fw-bold mb-2">{t("status")}</label>
                        <select
                          className="form-select rounded-3 border-light bg-light text-dark fw-bold text-13 shadow-none"
                          value={filter_status}
                          onChange={(e) => this.setState({ filter_status: e.target.value })}
                        >
                          <option value="">{t("all_status")}</option>
                          <option value="operational">{t("operational")}</option>
                          <option value="maintenance">{t("under_maintenance")}</option>
                          <option value="issue">{t("issue_reported")}</option>
                        </select>
                      </div>
                      <div className="flex-grow-1" style={{ minWidth: '200px' }}>
                        <label className="form-label text-secondary text-12 fw-bold mb-2">{t("location")}</label>
                        <select
                          className="form-select rounded-3 border-light bg-light text-dark fw-bold text-13 shadow-none"
                          value={filter_location}
                          onChange={(e) => this.setState({ filter_location: e.target.value })}
                        >
                          <option value="">{t("all_locations")}</option>
                          {sortOptions(lookups.locations).map((location) => (
                            <option key={location} value={location}>{location}</option>
                          ))}
                        </select>
                      </div>
                      <button
                        className="btn btn-primary px-4 fw-bold rounded-3 shadow-sm border-0 d-flex align-items-center"
                        style={{ height: '42px' }}
                        onClick={() => this.Get()}
                      >
                        <span className="icon me-2">{"\uf0b0"}</span> {t("apply_filters")}
                      </button>
                      <button
                        className="btn btn-white border px-3 fw-bold rounded-3 d-flex align-items-center text-success shadow-none"
                        style={{ height: '42px' }}
                        disabled={!!exporting}
                        onClick={() => this.exportFile("excel")}
                      >
                        <span className="icon me-2">{"\uf1c3"}</span> {exporting === "excel" ? t("loading") : t("export_excel")}
                      </button>
                    </div>
          
                    {/* KPI Summary Cards */}
                    <div className="row g-3 mb-4">
                      <div className="col-lg-3 col-md-6">
                        <div className="card border-0 border-start border-5 border-primary rounded-4 shadow-sm p-3 bg-white h-100">
                          <div className="text-primary text-12 fw-bold mb-1">{t("total_assets")}</div>
                          <h2 className="fw-bold text-dark mb-1">{summary.total_assets}</h2>
                          <div className="text-primary text-10 fw-bold">{t("under_contract")}</div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="card border-0 border-start border-5 border-success rounded-4 shadow-sm p-3 bg-white h-100">
                          <div className="text-success text-12 fw-bold mb-1">{t("operational")}</div>
                          <h2 className="fw-bold text-dark mb-1">{summary.operational}</h2>
                          <div className="text-success text-10 fw-bold">{t("uptime")}</div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="card border-0 border-start border-5 border-warning rounded-4 shadow-sm p-3 bg-white h-100">
                          <div className="text-warning text-12 fw-bold mb-1">{t("under_maintenance")}</div>
                          <h2 className="fw-bold text-dark mb-1">{summary.under_maintenance}</h2>
                          <div className="text-warning text-10 fw-bold">{t("scheduled_pm")}</div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="card border-0 border-start border-5 border-danger rounded-4 shadow-sm p-3 bg-white h-100">
                          <div className="text-danger text-12 fw-bold mb-1">{t("warranty_expiring")}</div>
                          <h2 className="fw-bold text-dark mb-1">{summary.warranty_expiring}</h2>
                          <div className="text-danger text-10 fw-bold">{t("within_30_days")}</div>
                        </div>
                      </div>
                    </div>
          
                    {/* Graphs Area */}
                    <div className="row g-4 mb-4">
                      <div className="col-lg-8">
                        <div className="card border-0 rounded-4 shadow-sm p-4 bg-white h-100">
                          <h6 className="fw-bold text-dark mb-4">{t("asset_status_distribution")}</h6>
                          <div style={{ height: '250px' }}>
                            {status_distribution.length === 0 ? (
                              <div className="d-flex align-items-center justify-content-center bg-light rounded-3 h-100 text-secondary">
                                {loaded ? t("no_data") : t("loading")}
                              </div>
                            ) : (
                              <Bar data={this.distributionData()} options={BAR_OPTIONS} />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="card border-0 rounded-4 shadow-sm p-4 bg-white h-100">
                          <h6 className="fw-bold text-dark mb-4">{t("maintenance_by_asset")}</h6>
                          <div style={{ height: '250px' }}>
                            {maintenance_by_asset.length === 0 ? (
                              <div className="d-flex align-items-center justify-content-center h-100 text-secondary">
                                {loaded ? t("no_data") : t("loading")}
                              </div>
                            ) : (
                              <Doughnut data={this.maintenanceData()} options={DONUT_OPTIONS} />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
          
                    {/* Details Table */}
                    <div className="card border-0 rounded-4 shadow-sm pb-2 overflow-hidden bg-white">
                      <div className="p-4 border-bottom border-light">
                        <h6 className="fw-bold text-dark mb-0">{t("asset_details")}</h6>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                          <thead>
                            <tr className="text-secondary fw-bold text-12 border-bottom border-light bg-light bg-opacity-50">
                              <th className="py-3 px-4 border-0">{t("asset_id")}</th>
                              <th className="py-3 border-0">{t("name")}</th>
                              <th className="py-3 border-0">{t("category")}</th>
                              <th className="py-3 border-0">{t("location")}</th>
                              <th className="py-3 border-0 text-center">{t("status")}</th>
                              <th className="py-3 border-0 text-center">{t("last_pm")}</th>
                              <th className="py-3 border-0 text-center">{t("next_pm")}</th>
                              <th className="py-3 border-0 text-center">{t("warranty")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.length === 0 ? (
                              <tr>
                                <td colSpan={8} className="text-center text-secondary py-4">{loaded ? t("no_data") : t("loading")}</td>
                              </tr>
                            ) : data.map((item) => (
                              <tr key={item.uid} className="border-bottom border-light">
                                 <td className="py-3 px-4 fw-bold text-primary text-13" style={{ color: "#8A2BE2" }}>{item.asset_code || "-"}</td>
                                    <td className="text-dark fw-medium text-13">{item.name || "-"}</td>
                                    <td className="text-secondary text-13">{item.category || "-"}</td>
                                    <td className="text-secondary text-13">{item.location || "-"}</td>
                                    <td>
                                        <span className={`badge bg-${statusColor(item.status)}-light text-${statusColor(item.status)} rounded-pill px-3 py-1 fw-bold text-10 border border-${statusColor(item.status)} border-opacity-10`}>
                                            {translateKey(item.status)}
                                        </span>
                                    </td>
                                    <td className="text-secondary text-13">{formatDate(item.last_pm) || "-"}</td>
                                    <td className="text-secondary text-13">{formatDate(item.next_pm) || "-"}</td>
                                    <td className="px-4">
                                        <span className={`badge bg-${statusColor(item.warranty_status)}-light text-${statusColor(item.warranty_status)} rounded-pill px-3 py-1 fw-bold text-10 border border-${statusColor(item.warranty_status)} border-opacity-10`}>
                                            {translateKey(item.warranty_status)}
                                        </span>
                                    </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
        </div>
      </div>
    );
  }
}
